import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactModal from 'react-modal';
// @ts-ignore
import css from "./index.css?inline";
import AppState from './AppState';
import { getDateCompareCollector, getImportantCollector, getAllCollector } from './helpers/collectors'
import { Config } from './types';

const getTables = (config: Config) => [
    {
        id: 'newest',
        title: 'This just in',
        collector: getDateCompareCollector(config.options['naskalit-show-days-before'], config.options['naskalit-ignore-before']),
        important: "add",
    },
    {
        id: 'important',
        title: 'Tärkeet nuotit',
        collector: getImportantCollector(),
        important: "remove",
    },
    {
        id: 'all',
        title: 'Kaikki nuotit',
        collector: getAllCollector(),
        important: "add",
        searchEnabled: true,
    }
]

export const appendNewShadowRoot = (host: HTMLElement) => {
    // create a shadow root inside it
    const shadow = host.attachShadow({ mode: 'open' })
    const renderIn = document.createElement('div')

    const style = document.createElement('style')
    style.textContent = css

    shadow.appendChild(style)
    shadow.appendChild(renderIn)

    return renderIn
}

const root = document.getElementById('naskalit-frontend')

if (root) {
    // @ts-ignore
    const wpApiSettings = window.wpApiSettings
    const state = new AppState({...wpApiSettings, tables: getTables(wpApiSettings)})
    const appRoot = appendNewShadowRoot(root)

    ReactModal.setAppElement(appRoot);

    ReactDOM.render(
    <React.StrictMode>
        <App state={state} />
    </React.StrictMode>,
    appRoot
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();

}